export default {"src":"/_next/static/media/dynamicFeedIcon.13637923.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};